module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/from-browser.js
// module id = r9kI
// module chunks = 2